/**
 * <sc-breadcrumbs> upgrades the collection crumb on a product page when document.referrer shows the shopper arrived
 * through a collection.
 */
if (!customElements.get('sc-breadcrumbs')) {
  customElements.define(
    'sc-breadcrumbs',
    class extends HTMLElement {
      connectedCallback() {
        const breadcrumbList = this.querySelector('.breadcrumbs__list');
        if (!breadcrumbList || breadcrumbList.children.length < 2) return;

        const referrerCollection = this.#referrerCollection();
        if (!referrerCollection) return;

        // Cloning the Home item keeps the class list and the separator in Liquid rather than duplicating them here.
        const collectionCrumb = breadcrumbList.firstElementChild.cloneNode(true);
        const collectionCrumbLink = collectionCrumb.querySelector('a');
        if (!collectionCrumbLink) return;

        collectionCrumbLink.textContent = referrerCollection.title;
        collectionCrumbLink.setAttribute('href', referrerCollection.url);
        breadcrumbList.insertBefore(collectionCrumb, breadcrumbList.lastElementChild);
      }

      /**
       * The collection the shopper came through, or null. Null unless the referrer is a same origin collection page
       * whose handle is one this product actually belongs to.
       */
      #referrerCollection() {
        if (!document.referrer) return null;

        let referrerPath;

        try {
          const referrerUrl = new URL(document.referrer);

          if (referrerUrl.origin !== window.location.origin) return null;

          referrerPath = referrerUrl.pathname;
        } catch {
          return null;
        }

        // Unanchored so locale prefixed paths such as /en-gb/collections/bottoms still match.
        const collectionPathMatch = referrerPath.match(/\/collections\/([^/?#]+)/);
        if (!collectionPathMatch) return null;

        const referrerCollectionHandle = collectionPathMatch[1];
        const matchedCollection = this.#productCollections().find(
          (productCollection) => productCollection.handle === referrerCollectionHandle
        );

        if (!matchedCollection) return null;

        return {
          title: matchedCollection.title,
          // Keep any locale prefix, drop anything after the handle such as a tag filter.
          url: referrerPath.slice(0, collectionPathMatch.index + collectionPathMatch[0].length),
        };
      }

      #productCollections() {
        try {
          return JSON.parse(this.dataset.productCollections) ?? [];
        } catch {
          return [];
        }
      }
    }
  );
}
